import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import '@/imports';
import { i18n } from '@/locales';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
